module.exports = require('./lib/xpath')
